import { defineStore } from "pinia";

import UrlsApi, { UrlsApi as iUrlsApi }  from "@Modules/urls/Api/UrlsApi";

export const XUrlsStore = defineStore("x-url", (): iUrlsApi => {
  return UrlsApi();
});
